/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import configuredDayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isToday from 'dayjs/plugin/isToday';
import isTomorrow from 'dayjs/plugin/isTomorrow';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

configuredDayjs.extend(advancedFormat);
configuredDayjs.extend(customParseFormat);
configuredDayjs.extend(duration);
configuredDayjs.extend(isSameOrAfter);
configuredDayjs.extend(isToday);
configuredDayjs.extend(isTomorrow);
configuredDayjs.extend(relativeTime);
configuredDayjs.extend(utc);
configuredDayjs.extend(timezone);

export type { Dayjs } from 'dayjs';

export default configuredDayjs;
